import { LinkModalInterface } from '../interfaces/ProjectInterface';
import { ThemeState } from '../interfaces/SettingsInterface';
export const DATE_FORMAT = 'YYYY-MMM-DD';
export const ONESIGNAL_APP_ID = '146d5180-8b38-4d86-8422-890aa85f7ac1';
export const HIDE_INVITE_TEAMMATE_BUTTON = 'hide_invite_teammate_button';

// Client-side image compression limits applied before Firebase Storage upload.
export const IMAGE_COMPRESSION = {
  // Default resize width, and base quality used as the starting point before any byte-cap reduction.
  DEFAULT_MAX_WIDTH: 2000,
  DEFAULT_QUALITY: 0.85,
  // Editor images (task/comment/message): full quality, only resized (no quality reduction).
  EDITOR_QUALITY: 1,
  // Profile photos & workspace logos: hard-capped dimensions and file size.
  AVATAR_MAX_WIDTH: 256,
  AVATAR_MAX_HEIGHT: 256,
  AVATAR_MAX_SIZE_BYTES: 50 * 1024,
  // Lowest quality we drop to before shrinking dimensions to meet a byte cap.
  MIN_QUALITY: 0.4,
  // Smallest width/height (px) we shrink to when meeting a byte cap.
  MIN_DIMENSION: 16
};

export const STORAGE_KEYS = {
  USER_PREFERENCES: 'UserPreferences',
  DEVICE_ID: 'deviceId'
};

export const USER_ROLE = {
  USER: 0,
  ADMIN: 1,
  CLIENT: 2
};

export const PROJECT_STATUS = {
  NOT_STARTED: 1,
  ON_SCHEDULE: 2,
  BEHIND_SCHEDULE: 3,
  AT_RISK: 4
};

export const PROJECT_STATUS_TEXT: { [key: number]: string } = {
  1: 'Not Started yet',
  2: 'On Schedule',
  3: 'Behind Schedule',
  4: 'At Risk'
};

export const APP_INIT_RESPONSE_TYPE = {
  SUCCESS: 'sucess',
  FAILED: 'failed',
  REDIRECT: 'redirect'
};

export const PROJECT_STATUS_COLOR: { [key: number]: string } = {
  1: 'var(--neutral-primary)',
  2: 'var(--accent-success)',
  3: 'var(--accent-warning)',
  4: 'var(--accent-highlight)'
};

export const CREATE_INVOICE_TYPE = {
  TRACKED_TIME_AND_EXPENSE: 'tracked time and expense',
  BLANK_INVOICE: 'blank invoice'
};

export const NOTIFICATION_TYPE = {
  INVITE: 1,
  TASK: 2,
  COMMENT: 3,
  PROJECT_INVITE: 4,
  VIEWS: 5
};

export const TASK_LIST_TYPE = {
  TASKS: 1,
  TASK_GRID: 2,
  CALENDAR_VIEW: 3
};

export const TASK_LIST_TYPE_LABEL: { [key: number]: string } = {
  1: 'List',
  2: 'Grid',
  3: 'Calendar'
};

export const FILE_TYPES = {
  FOLDER: 1,
  UPLOAD: 2,
  DOCS: 3,
  DRIVE: 4,
  DROPBOX: 5,
  ONEDRIVE: 6,
  FIGMA: 7,
  WHITEBOARD: 8,
  NOTION: 9,
  RESOURCES: 10,
  ADD_LINK: 11
};

export const INBOX_FILTER_TYPE = {
  ALL: 1,
  ASSIGN_TO_ME: 2,
  MENTION: 3
};

export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const INVOICE_TYPE = {
  OPEN: 1,
  ALL: 2
};

export const BILLABLE_HOURS = {
  ALL_UNINVOICED_BILLABLE_HOURS: 1,
  INCLUDE_UNINVOICES_BILLABLE_HOURS_FROM: 2,
  DO_NOT_INCLUDE_ANY_HOURS: 3
};

export const DISPLAY_HOURS = {
  BY_TASK: 1,
  BY_PERSON: 2,
  BY_PROJECT: 3,
  BY_TASKGROUP: 4,
  DETAILED: 5
};

export const ACTIVITY_ACTION: { [key: number]: string } = {
  1: 'Added',
  3: 'Updated',
  6: 'Archived',
  4: 'Deleted'
};

export const ACTIVITY_TYPE: { [key: number]: string } = {
  5: 'Project Users',
  6: 'Project',
  7: 'Task',
  9: 'File',
  10: 'Document',
  13: 'Task Group',
  14: 'Priority Setting',
  15: 'Estimation Setting',
  16: 'Milestone Setting'
};

export const SHOW_TASK_GROUPING_TYPE = {
  NO_GROUPING: 0,
  DEFAULT: 1,
  GROUPING_BY_PRIORITY: 2,
  GROUPING_BY_USER: 3,
  GROUPING_BY_MILESTONE: 4,
  GROUPING_BY_STATUS: 5,
  GROUPING_BY_GROUP: 6,
  GROUPING_BY_PROJECT: 7
};

export const SHOW_TASK_BY_ORDER = {
  DUE_DATE: 1,
  CREATED_DATE: 2,
  CUSTOM: 3,
  PRIORITY: 4
};

export const INVOICE_STATUS = {
  DRAFT: 1,
  SAVE: 3
};

export const INVOICE_STATUS_TYPE = {
  NONE: 0,
  DRAFT: 1,
  OVER_DUE: 2,
  PENDING: 3,
  PARTIALLY_PAID: 4,
  PAID: 5
};

export const TASK_PRIORITY_LABELS: { [key: number]: string } = {
  0: 'No Priority',
  1: 'Urgent',
  2: 'High',
  3: 'Medium',
  4: 'Low'
};

export const TASK_PRIORITY = {
  NO_PRIORITY: 0,
  URGENT: 1,
  HIGH: 2,
  MEDIUM: 3,
  LOW: 4
};

export const TASK_REPORT_TIME_TYPE = {
  PAST: 0,
  FUTURE: 1,
  NODATE: 2
};

export const TASK_REPORT_STATUS = {
  PENDING: 0,
  COMPLETED: 1
};

export const MY_TASKS_GROUP_FILTER_TYPE = {
  GROUP: 5,
  DUE_DATE: 1,
  PROJECT: 2,
  PRIORITY: 3,
  NONE: 4
};

export const MY_TASKS_GROUP_FILTER_TYPE_LABELS: { [key: number]: string } = {
  5: 'Group',
  1: 'Due Date',
  2: 'Project',
  3: 'Priority'
};

export const COMMENT_TYPE = {
  COMMENT: 0,
  SET_DUE_DATE: 1,
  CHANGE_DUE_DATE: 2,
  ADD_ASSIGNEE: 3,
  REMOVE_ASSIGNEE: 4,
  UNASSIGN: 5,
  CHANGE_PRIORITY: 6,
  CHANGE_GROUP: 7,
  UPDATE_TASK: 8,
  REMOVE_DUE_DATE: 9,
  STATUS_CHANGE: 10,
  ESTIMATE_TIME: 11,
  AUDIO: 12,
  SET_MILESTONE: 13,
  ADD_LABEL: 14,
  REMOVE_LABEL: 15,
  STATUS_ID_CHANGE: 16,
  CREATE_TASK: 17
};

export const WORKSPACE_TEAM_TYPE: { [key: number]: string } = {
  1: 'Personal',
  2: 'Freelance Business',
  3: 'Team/Organization'
};

export const TIME_REPORT_VIEW_TYPE_ID = {
  BY_PROJECT: 1,
  BY_MEMBER: 2,
  BY_ACTIVITY: 3,
  BY_LABELS: 4
};

export const TIME_REPORT_DATA_FILTER_ID = {
  WORKSUMMARY: 1,
  TIMESHEET: 2,
  ACTIVITYLOG: 3
};

export const TIME_DATE_SELECTED_TEXT = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  THIS_WEEK: 'This Week',
  LAST_WEEK: 'Last Week',
  LAST_7_DAYS: 'Last 7 Days',
  THIS_MONTH: 'This Month',
  LAST_MONTH: 'Last Month',
  LAST_30_DAYS: 'Last 30 Days',
  CUSTOM: 'Custom'
};

export const TIME_REPORT_CHART_TYPE_ID = {
  PROJECT: 1,
  MEMBER: 2
};

export const COLOR_THEME = {
  LIGHT: 1,
  DARK: 2,
  SYSTEM_DEFAULT: 3
};

export const COLOR_THEME_TYPE = {
  LIGHT: 'light',
  DARK: 'dark',
  SYSTEM: 'system'
};

export const COLOR_THEME_TEXT: { [key: string]: string } = {
  1: 'Light',
  2: 'Dark',
  3: 'System'
};

export const CUSTOMER_MEMBER_ROLE = {
  NO_ACCESS: 1,
  PROJECT_ONLY: 2,
  FULL_ACCESS: 3
};
export const FILE_EXTENSIONS = [
  'iconpdf',
  '.folder',
  '.docx',
  '.jpg',
  '.avif',
  '.png',
  '.jpeg',
  '.doc',
  '.pdf',
  '.mp4',
  '.pptx',
  '.psd',
  '.sketch',
  '.html',
  '.zip',
  '.mp3',
  '.ai',
  '.xd',
  '.xlsx',
  '.xls',
  '.figma'
];

export const FILES_LIST_TYPE = {
  LIST: 1,
  GRID: 2
};
export const SHARE_TYPE = {
  snap: 1,
  doc: 2
};

export const LABEL_COLOURS = [
  { label: 'Red', color: 'var(--accent-error)' },
  { label: 'Orange', color: 'var(--accent-caution)' },
  { label: 'Yellow', color: 'var(--accent-highlight)' },
  { label: 'Green', color: 'var(--accent-success)' },
  { label: 'Teal', color: 'var(--accent-primary)' },
  { label: 'Purple', color: 'var(--accent-secondary)' },
  { label: 'Dark grey', color: '#81878E' },
  { label: 'Grey', color: 'var(--neutral-primary)' }
];

export const LABEL_COLOUR_HASH: { [key: string]: string } = {
  Red: 'var(--accent-error)',
  Orange: 'var(--accent-caution)',
  Yellow: 'var(--accent-highlight)',
  Green: 'var(--accent-success)',
  Teal: 'var(--accent-primary)',
  Purple: 'var(--accent-secondary)',
  'Dark grey': '#81878E',
  Grey: 'var(--neutral-primary)'
};

export const CHAT_GROUP_TYPE = {
  PERSONAL: 1,
  PROJECT: 2
};

export const INVOICING_DUE_ISSUE = {
  UPON_RECEIPT: 0,
  TEN_DAYS: 10,
  FIFTEEN_DAYS: 15,
  THIRTY_DAYS: 30,
  SIXTY_DAYS: 60
};

export const imageExtensions = ['.jpg', '.png', '.jpeg'];
export const videoExtensions = ['.mp4', '.mov', '.mkv', '.webm'];
export const audioExtensions = ['.mp3'];

export const DOCUMENT_FILE_ICON_URL =
  'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2Ffile-icon.svg?alt=media&token=93e9dbac-469e-4d76-8af6-18dc4480fc33';
export const DOCUMENT_CLOSE_ICON_URL =
  'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FIcon-cross.svg?alt=media&token=f208d538-4b7d-4ea1-a577-5c23db75d19c';

export const TIMER_STATUS = {
  START: 1,
  PAUSE: 2,
  STOP: 3
};

export const TABS_COMMAND_K = {
  1: 'All',
  2: 'Projects',
  3: 'People',
  4: 'Tasks',
  5: 'Customers'
};

export const TABS_COMMAND_K_ID = {
  ALL: 1,
  PROJECTS: 2,
  PEOPLE: 3,
  TASKS: 4,
  CUSTOMERS: 5
};

export const dateFormats = [
  'DD MMM YYYY',
  'MMM DD, YYYY',
  'DD/MM/YYYY',
  'MM/DD/YYYY',
  'YYYY/MM/DD',
  'YYYY-MM-DD',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'YYYY.MM.DD',
  'MM.DD.YYYY',
  'DD.MM.YYYY',
  'YY/MM/DD',
  'DD/MM/YY',
  'MM/DD/YY'
];

export const DEFAULT_DATE_FORMAT = 'DD MMM YYYY';

export const STATUS_TYPE = {
  BACKLOG: 1,
  UNSTARTED: 2,
  IN_PROGRESS: 3,
  IN_REVIEW: 4,
  COMPLETED: 5,
  CANCELLED: 6
};

export const STATUS_TYPE_LABELS: { [key: number]: string } = {
  1: 'Backlog',
  2: 'Unstarted',
  3: 'In Progress',
  4: 'In Review',
  5: 'Completed',
  6: 'Cancelled'
};

export const SHOW_COMPLETED_TASK_BY_DATE = {
  ALL: 1,
  YESTERDAY: 2,
  LAST_WEEK: 3,
  LAST_MONTH: 4,
  NONE: 5
};

export const SHOW_COMPLETED_TASK_FILTER_NAME: { [key: number]: string } = {
  1: 'All',
  2: 'Yesterday',
  3: 'Last Week',
  4: 'Last Month',
  5: 'None'
};

export const PRIORITY_ICON_NAMES: { [key: number]: string } = {
  0: 'No-priority',
  1: 'Urgent',
  2: 'High',
  3: 'Medium',
  4: 'low'
};
export const MENU_OPTIONS = {
  EDIT: 1,
  DELETE: 2,
  SETTING: 3,
  ARCHIVE: 4,
  CLONE: 5,
  VIEW: 6,
  DUPLICATE: 7,
  RESTORE: 8,
  COPYLINK: 9,
  ADDLINK: 10,
  ADD_REACTION: 11,
  REPLY: 12
};

export const FILES_MENU_OPTIONS = {
  VIEW: 1,
  RENAME: 2,
  MOVETOFOLDER: 3,
  DELETE: 4,
  DOWNLOAD: 5,
  COPYLINK: 6
};

export const SETTING_TEAMS_MENU_OPTION = {
  ADMIN: 1,
  DELETE: 2
};

export const PROJECT_FILTER_TYPE = {
  ALPHABETIC: 1,
  CREATED_DATE: 2
};

export const UPLOAD_FILES_MENU_OPTION = {
  UPLOAD_FILE: 1,
  SELECT_FILE: 2
};

export const PROJECT_SETTINGS_MENU_OPTION = {
  EDIT: 1,
  SET_AS_DEFAULT: 2,
  DELETE: 3
};

export const THEME_STATES: { [key: string]: ThemeState } = {
  light: { light: true, dark: false, system: false },
  dark: { light: false, dark: true, system: false },
  system: { light: false, dark: false, system: true }
};

export const priorityList = [
  { key: 0, name: 'No Priority', iconName: 'Priority-No-priority-icon' },
  { key: 1, name: 'Urgent', iconName: 'Priority-Urgent-icon' },
  { key: 2, name: 'High', iconName: 'Priority-High-icon' },
  { key: 3, name: 'Medium', iconName: 'Priority-Medium-icon' },
  { key: 4, name: 'Low', iconName: 'Priority-low-icon' }
];
export const REPORT_PAYMENT_LOADING_STATE_DATA = [
  {
    title: 'Invoice No',
    columnWidth: 100,
    contentWidth: 48
  },
  {
    title: 'Projects',
    columnWidth: 362,
    contentWidth: 270
  },
  {
    title: 'Client Company',
    columnWidth: 170,
    contentWidth: 92
  },
  {
    title: 'Paid On',
    columnWidth: 170,
    contentWidth: 59
  },
  {
    title: 'Paid Amount',
    columnWidth: 170,
    contentWidth: 92,
    alignPlace: '-webkit-right'
  }
];

export const REPORT_INVOICE_LOADINGSTATE_DATA = [
  {
    title: 'Status',
    columnWidth: 100,
    contentWidth: 64
  },
  {
    title: 'Paid On',
    columnWidth: 103,
    contentWidth: 64
  },
  {
    title: 'Due On',
    columnWidth: 99,
    contentWidth: 64
  },
  {
    title: 'Invoice No',
    columnWidth: 120,
    contentWidth: 64
  },
  {
    title: 'Projects Name',
    columnWidth: 320,
    contentWidth: 216
  },
  {
    title: 'Rate',
    columnWidth: 120,
    contentWidth: 82,
    alignPlace: '-webkit-right'
  },
  {
    title: 'Discount',
    columnWidth: 100,
    contentWidth: 82,
    alignPlace: '-webkit-right'
  }
];

type FileType =
  | 'FIGMA'
  | 'NOTION'
  | 'ONEDRIVE'
  | 'DROPBOX'
  | 'DRIVE'
  | 'WHITEBOARD'
  | 'DOCS'
  | 'FOLDER'
  | 'RESOURCES'
  | 'FILE'
  | 'ADDLINK';

export const LINK_FILE_DATA: Record<FileType, LinkModalInterface> = {
  FIGMA: {
    modalType: FILE_TYPES.FIGMA,
    modal: 'Figma',
    name: 'modal-figma-icon',
    title: 'Add files from Figma',
    placeholder: 'What’s the title for this?',
    label: 'Paste the Figma link here or',
    href: 'https://www.figma.com',
    placeholder2: 'Paste the Figma link here...'
  },
  NOTION: {
    modal: 'Notion',
    modalType: FILE_TYPES.NOTION,
    name: 'notion-icon',
    title: 'Add files from Notion',
    placeholder: 'What’s the title for this?',
    label: 'Paste the Notion link here',
    placeholder2: 'Paste the Notion link here...'
  },
  ONEDRIVE: {
    modal: 'OneDrive',
    modalType: FILE_TYPES.ONEDRIVE,
    name: 'modal-onedrive-icon',
    title: 'Add files from OneDrive',
    placeholder: 'What’s the title for this?',
    label: 'Paste the OneDrive link here or',
    href: 'https://onedrive.live.com/?id=root',
    placeholder2: 'Paste the OneDrive link here...'
  },
  DROPBOX: {
    modal: 'Dropbox',
    modalType: FILE_TYPES.DROPBOX,
    name: 'modal-dropbox-icon',
    title: 'Add files from Dropbox',
    placeholder: 'What’s the title for this?',
    label: 'Paste the Dropbox link here or',
    href: 'https://www.dropbox.com/login',
    placeholder2: 'Paste the Dropbox link here...'
  },
  DRIVE: {
    modal: 'Google Drive',
    modalType: FILE_TYPES.DRIVE,
    name: 'modal-googledrive-icon',
    title: 'Add files from Google Drive',
    placeholder: 'What’s the title for this?',
    label: 'Paste the Google Drive link here or',
    href: 'https://drive.google.com/drive/my-drive',
    placeholder2: 'Paste the Google Drive link here...'
  },
  WHITEBOARD: {
    modalType: FILE_TYPES.WHITEBOARD,
    title: 'Create Whiteboard',
    placeholder: 'Enter Whiteboard name',
    name: 'Whiteboard'
  },
  DOCS: {
    modalType: FILE_TYPES.DOCS,
    title: 'Create Document',
    placeholder: 'Enter Document name',
    name: 'Document'
  },
  FOLDER: {
    modalType: FILE_TYPES.FOLDER,
    title: 'Create Folder',
    placeholder: 'Enter Folder name',
    name: 'Folder'
  },
  FILE: {
    modalType: FILE_TYPES.FOLDER,
    title: 'Rename File',
    placeholder: 'Enter File name',
    name: 'File'
  },
  RESOURCES: {
    modalType: FILE_TYPES.RESOURCES,
    name: 'copy-link-icon',
    title: 'Add link to project',
    updateTitle: 'Edit link',
    label1: 'Title (Optional)',
    placeholder: 'What’s the title for this?',
    label: 'URL',
    placeholder2: 'Paste the link here'
  },
  ADDLINK: {
    modalType: FILE_TYPES.ADD_LINK,
    name: 'copy-link-icon',
    title: 'Add link to task',
    updateTitle: 'Edit link',
    label1: 'Title (Optional)',
    placeholder: 'What’s the title for this?',
    label: 'URL',
    placeholder2: 'Paste the link here'
  }
};

export const CustomerDetailMoreMenu = [
  {
    key: MENU_OPTIONS.EDIT,
    label: 'Edit'
  },
  {
    key: MENU_OPTIONS.DELETE,
    label: 'Delete'
  }
];

export const TimeLogMenuItems = [
  'Today',
  'Yesterday',
  'This week',
  'Last week',
  'Last 7 days',
  'This month',
  'Last month'
];

export const responsiveDropdownMenuItems = [
  { key: MENU_OPTIONS.ADD_REACTION, label: 'Add reaction', iconName: 'reaction-icon' },
  { key: MENU_OPTIONS.REPLY, label: 'Reply', iconName: 'reply-icon' },
  { key: MENU_OPTIONS.EDIT, label: 'Edit', iconName: 'edit-icon' },
  { key: MENU_OPTIONS.DELETE, label: 'Delete', iconName: 'updated-delete-icon' }
];
export const dropdownMenuItems = [
  { key: MENU_OPTIONS.EDIT, label: 'Edit' },
  { key: MENU_OPTIONS.DELETE, label: 'Delete' }
];
export const roleOptions = [
  {
    key: 1,
    iconName: 'no-icon',
    label: 'No Access',
    description: 'No login access provided',
    roleValue: 1,
    iconTone: 'stroke'
  },
  {
    key: 2,
    iconName: 'project-icon',
    label: 'Project Only',
    description: 'This will have only project access',
    roleValue: 2
  },
  {
    key: 3,
    iconName: 'access-icon',
    label: 'Full Access',
    description: 'This will have project and invoice access',
    roleValue: 3
  }
];

export const InvoiceMoreMenuItems = [
  { key: MENU_OPTIONS.VIEW, label: 'View' },
  { key: MENU_OPTIONS.EDIT, label: 'Edit' },
  { key: MENU_OPTIONS.DUPLICATE, label: 'Duplicate' },
  { key: MENU_OPTIONS.DELETE, label: 'Delete' }
];

export const InvoiceDraftMoreMenuItem = [
  { key: MENU_OPTIONS.EDIT, label: 'Edit' },
  { key: MENU_OPTIONS.DUPLICATE, label: 'Duplicate' },
  { key: MENU_OPTIONS.DELETE, label: 'Delete' }
];

export const DRAFT_MESSAGE_TYPE = {
  MESSAGE: 1,
  COMMENT: 2
};

export const RESOURCE_TYPE = {
  FILE: 1,
  LINK: 2
};

export const PrioritySortOrder = [
  TASK_PRIORITY.URGENT,
  TASK_PRIORITY.HIGH,
  TASK_PRIORITY.MEDIUM,
  TASK_PRIORITY.LOW,
  TASK_PRIORITY.NO_PRIORITY
];

export const STATUS_ORDER = [
  STATUS_TYPE.UNSTARTED,
  STATUS_TYPE.IN_PROGRESS,
  STATUS_TYPE.IN_REVIEW,
  STATUS_TYPE.BACKLOG,
  STATUS_TYPE.COMPLETED,
  STATUS_TYPE.CANCELLED
];

export const invoiceDueOptions = [
  { id: 'upon_receipt', value: INVOICING_DUE_ISSUE.UPON_RECEIPT, label: 'Upon receipt' },
  { id: 'ten_days', value: INVOICING_DUE_ISSUE.TEN_DAYS, label: 'After :num days (NET 10)' },
  { id: 'fifteen_days', value: INVOICING_DUE_ISSUE.FIFTEEN_DAYS, label: 'After :num days (NET 15)' },
  { id: 'thirty_days', value: INVOICING_DUE_ISSUE.THIRTY_DAYS, label: 'After :num days (NET 30)' },
  { id: 'sixty_days', value: INVOICING_DUE_ISSUE.SIXTY_DAYS, label: 'After :num days (NET 60)' }
];

export const displayHoursOptions = [
  {
    id: 'by-task',
    value: DISPLAY_HOURS.BY_TASK,
    label: 'By Task: Combine all hours for one task into one line'
  },
  {
    id: 'by-person',
    value: DISPLAY_HOURS.BY_PERSON,
    label: 'By Person: Combine all hours for one person into one line'
  },
  {
    id: 'by-project',
    value: DISPLAY_HOURS.BY_PROJECT,
    label: 'By Project: Combine all hours for one project into one line'
  }
];

export const invoiceTypeOptions = [
  {
    id: 'tracked-time',
    value: CREATE_INVOICE_TYPE.TRACKED_TIME_AND_EXPENSE,
    label: 'Create an invoice for tracked time and expenses'
  },
  {
    id: 'blank-invoice',
    value: CREATE_INVOICE_TYPE.BLANK_INVOICE,
    label: 'Create a blank invoice'
  }
];

export const SHOW_TASK_GROUPING_NAME: { [key: number]: string } = {
  0: 'No Grouping',
  1: 'Default',
  2: 'Priority',
  3: 'User',
  4: 'Milestone',
  5: 'Status',
  6: 'Group',
  7: 'Project'
};

export const SHOW_TASK_ORDER_NAME: { [key: number]: string } = {
  1: 'Due Date',
  2: 'Created Date',
  3: 'Custom',
  4: 'Priority'
};

export const IMAGE_TYPE = {
  FIGMA: 'Figma' as const,
  INBOX: 'Inbox' as const,
  PRINT_SCREEN: 'PrintScreen' as const,
  YOUTUBE: 'Youtube' as const,
  SCREEN_RECORDING: 'ScreenRecording' as const,
  IMAGE: 'Image' as const
} as const;

export type ImageType = (typeof IMAGE_TYPE)[keyof typeof IMAGE_TYPE];

export const DESKTOP_VIEW = {
  CLOSE: 0,
  OPEN: 1
};

export const BREAKPOINTS = {
  mobile_xs: 320,
  mobile_s: 375,
  mobile_m: 393,
  mobile_l: 425,
  mobile_xl: 449,
  tablet_s: 768,
  tablet: 991,
  desktop_small: 1024,
  desktop_small_l: 1080,
  desktop_medium_sm: 1180,
  desktop_medium: 1280,
  desktop: 1440
};

export const statusItems = [
  { type: STATUS_TYPE.BACKLOG, label: 'Backlog', iconName: 'task-status-icon' },
  { type: STATUS_TYPE.UNSTARTED, label: 'Unstarted', iconName: 'task-todo-icon' },
  { type: STATUS_TYPE.IN_PROGRESS, label: 'In Progress', iconName: 'task-inprogress-icon' },
  { type: STATUS_TYPE.IN_REVIEW, label: 'In Review', iconName: 'task-inreview-icon' },
  { type: STATUS_TYPE.COMPLETED, label: 'Completed', iconName: 'task-completed-icon' },
  { type: STATUS_TYPE.CANCELLED, label: 'Cancelled', iconName: 'task-cancelled-icon' }
];
export const STATUS_ICON: { [key: number]: string } = {
  1: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FstatusIcons%2Fbacklog-icon.svg?alt=media&token=56aa9115-1dd6-4257-a996-0f7329e57e89',
  2: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FstatusIcons%2Ftodo-icon.svg?alt=media&token=8843296e-579c-4476-aee6-575fe97fbd87',
  3: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FstatusIcons%2Finprogress-icon.svg?alt=media&token=9c6a1198-98f5-4aed-8198-697f480d0c0a',
  4: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FstatusIcons%2Finreview-icon.svg?alt=media&token=87838692-19a2-47e0-b338-ebb2136be2c2',
  5: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FstatusIcons%2Fdone-icon.svg?alt=media&token=c34293b9-bc82-4851-a25e-9f3714ae13d1',
  6: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FstatusIcons%2Fcancel-icon.svg?alt=media&token=f9518d18-182d-4a1a-8199-80261cb92dd7'
};

export const PRIORITY_ICONS: { [key: number]: string } = {
  0: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FpriorityIcons%2FNo-Priority.svg?alt=media&token=fe423665-3afc-46e3-b310-be944ede339f',
  1: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FpriorityIcons%2FUrgent-Priority.svg?alt=media&token=dd5476be-b857-4063-b48a-6802341e52dc',
  2: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FpriorityIcons%2FHigh-Priority.svg?alt=media&token=1bb50450-5094-45ed-a44e-83e7578b95f6',
  3: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FpriorityIcons%2FMedium-Priority.svg?alt=media&token=e926a179-0093-4e15-b233-ade3607713e7',
  4: 'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FpriorityIcons%2FLow-Priority.svg?alt=media&token=8dc9afd8-4d43-4ee0-afc1-4de0ab7293b7'
};

export const ICON_COLORS: { [key: number]: string } = {
  1: '#666971',
  2: '#D042B1',
  3: '#D83426',
  4: '#E26D32',
  5: '#B5893C',
  6: '#5AA35D',
  7: '#4C9DAF',
  8: '#406FE2',
  9: '#904CE8'
};

export const ICON_TYPE = {
  DEFAULT: 1,
  ICON: 2,
  EMOJI: 3,
  IMAGE: 4
};

export const PROJECT_ICON_TYPE = {
  DEFAULT: 1,
  ICON: 2,
  EMOJI: 3,
  IMAGE: 4
};

export const BUTTON_TYPE = {
  PRIMARY: 1,
  SECONDARY: 2,
  CRITICAL: 3,
  TERTIARY: 4
};

export const TAB_BUTTON_TYPE = {
  STANDARD: 1,
  PILL: 2
};

export const CREATE_PROJECT_STEP = {
  ADD_INFO: 1,
  ADD_MEMBER: 2,
  SELECT_TEMPLATE: 3,
  TEMPLATE_PREVIEW: 4
};

export const DEPLOYMENT_STATUS_LABEL = {
  BUILDING: 'BUILDING',
  ERROR: 'ERROR',
  INITIALIZING: 'INITIALIZING',
  QUEUED: 'QUEUED',
  READY: 'READY',
  CANCELED: 'CANCELED'
};

export const TEMPLATE_DETAIL_TAB_TYPES = {
  TASKS: 1,
  SETTINGS: 2
};

export const APP_LOGO =
  'https://images.ctfassets.net/6v3c95narsix/46TdQdAUAQMY1THcYm7kHL/9c7fdb28efe046377618b39e1a0ffde3/Teamcamp_default.svg';

export const ICON_BUTTON_TYPE = {
  PRIMARY: 1,
  SECONDARY: 2,
  TERTIARY: 3
};

export const ICON_BUTTON_SIZE = {
  EXTRA_X_SMALL: 1,
  EXTRA_SMALL: 2,
  SMALL: 3,
  MEDIUM: 4,
  LARGE: 5,
  EXTRA_LARGE: 6,
  EXTRA_X_LARGE: 7
};

export const PLAN_UPGRADE_TYPE = {
  YEARLY: 1,
  MONTHLY: 2
};

export const USERS_PLAN_TYPE = {
  USERS: 1,
  UNLIMITED: 2
};

export const SUBSCRIPTION_PLAN = {
  MONTHLY_PAYMENT_SPECIFIC_USERS: 1,
  MONTHLY_PAYMENT_UNLIMITED_USERS: 2,
  YEARLY_PAYMENT_SPECIFIC_USERS: 3,
  YEARLY_PAYMENT_UNLIMITED_USERS: 4
};

export const DOMAIN_NAMES = ['dash.teamcamp.app', 'beta.teamcamp.app', 'localhost'];

export const TASK_FILTER_PROPERTY_TYPE = {
  ID: 'ID',
  STATUS: 'Status',
  PRIORITY: 'Priority',
  ASSIGNEE: 'Assignee',
  LABELS: 'Labels',
  MILESTONE: 'Milestone',
  DUE_DATE: 'Due date'
} as const;

export type TaskFilterPropertyType = (typeof TASK_FILTER_PROPERTY_TYPE)[keyof typeof TASK_FILTER_PROPERTY_TYPE];

export const CHIP_TYPE = {
  FILL: 1,
  FILL_WITHOUT_BORDER: 2,
  EMPTY: 3
};

export const CHIP_SIZE = {
  SMALL: 1,
  MEDIUM: 2
};
export const EMPTY_STATE_SIZE = {
  SMALL: 1,
  MEDIUM: 2
};

export const CHIP_ICON_POSITION = {
  DEFAULT: 1,
  TEXT_RIGHT_BUTTON: 2,
  AVATAR_TEXT: 3,
  AVATAR_TEXT_RIGHT_BUTTON: 4
};

export const FILE_ORDERING_TYPE = {
  NAME: 1,
  DATE_UPLOADED: 2,
  DATE_MODIFIED: 3,
  UPLOADED_BY: 4
};

export const DEFAULT_TASK_DISPLAY_PROPERTIES = {
  [TASK_FILTER_PROPERTY_TYPE.ID]: false,
  [TASK_FILTER_PROPERTY_TYPE.STATUS]: true,
  [TASK_FILTER_PROPERTY_TYPE.PRIORITY]: true,
  [TASK_FILTER_PROPERTY_TYPE.ASSIGNEE]: true,
  [TASK_FILTER_PROPERTY_TYPE.LABELS]: true,
  [TASK_FILTER_PROPERTY_TYPE.MILESTONE]: true,
  [TASK_FILTER_PROPERTY_TYPE.DUE_DATE]: true
};

export const AVATAR_BORDER = {
  THICK: 'thick',
  MEDIUM: 'medium',
  THIN: 'thin',
  NONE: 'none'
};

export const DEBOUNCE_DELAYS = {
  RESIZE: 100,
  SEARCH: 250
};

export const ASSIGN_REGEX = /Assigned you a task/i;
export const REOPEN_REGEX = /reopened a task/i;
export const COMPLETE_REGEX = /completed a task/i;
export const REPLY_MESSAGE_REGEX = /reply you/i;

export const ENABLE_NOTIFICATIONS_TEXT =
  'Enable notifications to receive real-time updates on task progress, new assignments, and important messages';

// Markers used to identify image-like content inside notification descriptions
export const IMAGE_CONTENT_MARKERS: string[] = [
  'figma-preview-image',
  'screen-recording-custom-main-div',
  'figma-link-div',
  'prnt-preview-main-div',
  '<img',
  'youtube-preview-main-div'
];

// Common image file extensions to help identify image content
export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];

// External link file types set — add new external link types here
export const EXTERNAL_LINK_TYPES = new Set([
  FILE_TYPES.DRIVE,
  FILE_TYPES.DROPBOX,
  FILE_TYPES.ONEDRIVE,
  FILE_TYPES.FIGMA,
  FILE_TYPES.NOTION
]);

// URL for old documentation, used in help center link and when opening docs in a new tab from the app
export const OLD_DOC_URL = 'https://blocksuit-client.vercel.app';

export const copyLinkSupportedTypes = [
  FILE_TYPES.UPLOAD,
  FILE_TYPES.DRIVE,
  FILE_TYPES.DROPBOX,
  FILE_TYPES.ONEDRIVE,
  FILE_TYPES.FIGMA,
  FILE_TYPES.NOTION
];

export const ICON_SIZE = {
  XS: 12,
  SM: 14,
  MD: 16,
  LG: 18,
  XL: 20,
  XXL: 24,
  XXXL: 28,
  XXXXL: 32
} as const;

export const languageOptions = [
  'Auto Detect',
  'bash',
  'cpp',
  'csharp',
  'clojure',
  'dart',
  'diff',
  'elixir',
  'graphql',
  'go',
  'haskell',
  'html',
  'java',
  'javascript',
  'json',
  'kotlin',
  'markdown',
  'ocaml',
  'perl',
  'php',
  'plaintext',
  'python',
  'r',
  'ruby',
  'rust',
  'css',
  'swift',
  'sql',
  'toml',
  'typescript',
  'yaml'
];

// Time-related constants
export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;

// UI-related constants
export const REORDER_INDEX_GAP = 500;

// Z-index constants (matching CSS variables in App.css)
export const Z_INDEX = {
  ZERO: 0,
  BASE: 1,
  MODAL: 1000
} as const;

// Subscription & invite constants
export const FREE_PLAN_TASK_LIMIT = 50;
export const INVITE_TEAMMATE_MAX_USERS = 5;
export const INVITE_DISMISS_EXPIRY_DAYS = 30;

// Screen recording upload limit.
export const MAX_RECORDING_FILE_SIZE = 2.5e8; // 250 MB
export const MAX_RECORDING_FILE_SIZE_LABEL = '250 MB';

// Debounce delay (ms) for batching display filter preference writes to Firestore.
export const PREFERENCE_WRITE_DEBOUNCE_MS = 300;

// Firestore caps a single writeBatch at 500 operations.
export const FIRESTORE_BATCH_LIMIT = 500;
